import { SalesReportData } from '../entities/SalesReport'
import { SalesReportRepository } from '../repositories/SalesReportRepository'

export class GetSalesReportUseCase {
  constructor(private readonly salesReportRepository: SalesReportRepository) {}

  async execute(): Promise<SalesReportData> {
    return this.salesReportRepository.getSalesReport()
  }
}
